<div class="info-bar-container">
  <div class="info-bar-column">
    <div>
      <span class="info-bar-label">{{ 'tourcode' | translate }}</span>
      <span>{{tourCode}}</span>
    </div>
  </div>
  <div class="info-bar-column" *ngIf="!transport && !homeDelivery">
    <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
  </div>

  <div class="info-bar-column" *ngIf="transport">
    <span class="info-bar-label">{{ 'leitcode' | translate }}</span>
    <span [style.margin-left]="isLoading ? 'auto' : '0'">{{transport.name}}</span>
    <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
  </div>

  <div class="info-bar-column" *ngIf="homeDelivery">
    <span class="info-bar-label">{{ 'homeDeliveryType' | translate }}</span>
    <span [style.margin-left]="isLoading ? 'auto' : '0'">{{ 'homeDeliveryKind.' + homeDelivery.kind | translate}}</span>
    <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
  </div>
</div>

<!-- show tour items if not in transport or home delivery, and not hidden by user -->
<app-tour-items-bar *ngIf="!hideItemsBar && !transport && !homeDelivery"></app-tour-items-bar>
